import {  Avatar  } from "@mui/material";

interface AvatarProps {
  alt?: string;
  src?: string;
  styles?: any;
  classes?: any;
}

class AvatarE extends React.PureComponent<AvatarProps, {}> {
  render() {
    const { alt, src, classes } = this.props;
    return <Avatar classes={classes} src={src} alt={alt} />;
  }
}

export default AvatarE;
